import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Plus } from 'lucide-react';

const MEAL_SERVICES = [
  { value: 'ubereats', label: 'Uber Eats', icon: '\u{1F354}' },
  { value: 'doordash', label: 'DoorDash', icon: '\u{1F697}' },
  { value: 'grubhub', label: 'Grubhub', icon: '\u{1F355}' },
  { value: 'seamless', label: 'Seamless', icon: '\u{1F961}' },
  { value: 'postmates', label: 'Postmates', icon: '\u{1F4E6}' },
  { value: 'instacart', label: 'Instacart (Groceries)', icon: '\u{1F6D2}' },
];

const AddIntegrationDialog = ({ open, onOpenChange, integration, setIntegration, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogTrigger asChild>
      <Button className="btn-primary" data-testid="add-integration-btn">
        <Plus className="w-4 h-4 mr-2" />
        Add Integration
      </Button>
    </DialogTrigger>
    <DialogContent className="surface-card">
      <DialogHeader>
        <DialogTitle>Add Integration</DialogTitle>
        <DialogDescription>Connect meal delivery or other services to help coordinate support</DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="integration-type">Integration Type</Label>
          <Select value={integration.integration_type} onValueChange={(value) => setIntegration({ ...integration, integration_type: value })}>
            <SelectTrigger data-testid="integration-type-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="meal_delivery">Meal Delivery</SelectItem>
              <SelectItem value="transportation" disabled>Transportation (Coming Soon)</SelectItem>
              <SelectItem value="pharmacy" disabled>Pharmacy (Coming Soon)</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="service-name">Service</Label>
          <Select value={integration.service_name} onValueChange={(value) => setIntegration({ ...integration, service_name: value })}>
            <SelectTrigger data-testid="service-name-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {MEAL_SERVICES.map((service) => (
                <SelectItem key={service.value} value={service.value}>{service.icon} {service.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="api-key">API Key / Account Info (Optional)</Label>
          <Input id="api-key" type="password" placeholder="Enter API key or leave blank" value={integration.config.api_key}
            onChange={(e) => setIntegration({ ...integration, config: { ...integration.config, api_key: e.target.value } })} />
          <p className="text-xs text-muted-foreground">Leave blank to manually coordinate orders. Add API key for automated features (future).</p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="preferences">Preferences / Notes</Label>
          <Textarea id="preferences" placeholder="Dietary restrictions, favorite restaurants, etc." value={integration.config.preferences}
            onChange={(e) => setIntegration({ ...integration, config: { ...integration.config, preferences: e.target.value } })} className="resize-none" />
        </div>
        <Button type="submit" className="w-full btn-primary" data-testid="submit-integration-btn">Add Integration</Button>
      </form>
    </DialogContent>
  </Dialog>
);

export { MEAL_SERVICES };
export default AddIntegrationDialog;
